import api from './axios';

export const getFuncionarios = (params = {}) =>
  api.get('/funcionarios', { params }).then((r) => r.data);

export const getFuncionariosPaginado = (params = {}) =>
  api.get('/funcionarios', { params }).then((r) => ({
    items: r.data,
    total: parseInt(r.headers['x-total-count'] || '0', 10),
  }));

export const getFuncionario = (id) =>
  api.get(`/funcionarios/${id}`).then((r) => r.data);

export const buscarPorCpf = (cpf) =>
  api.get('/funcionarios/buscar-cpf', { params: { cpf } }).then((r) => r.data).catch(() => null);

export const createFuncionario = (data) =>
  api.post('/funcionarios', data).then((r) => r.data);

export const updateFuncionario = (id, data) =>
  api.patch(`/funcionarios/${id}`, data).then((r) => r.data);
